import { ansImages, logos } from "#/constants";
import { Paragraph } from "@sicredi/react";
import React from "react";
import "./styles.scss";
import ResponsiveSpacing from "../ResponsiveSpacing";

export const AnsDetail: React.FC<{ company: keyof typeof ansImages }> = ({
  company,
}) => {
  return (
    <div className="ansFooter" data-testid="ansFooter">
      <ResponsiveSpacing appearanceDesktop="medium" appearanceMobile="small" />
      <Paragraph>
        TOTALITY INSP, sob o registro no 472248145
        <br />
        Central de Atendimento SulAmérica:{" "}
        <span className="bold">3003 1159</span>
      </Paragraph>
      <div className="logosBox">
        <img
          className="companyLogo"
          src={logos[company as keyof typeof logos]}
          alt=""
        />
        <img
          className="ansLogo"
          src={ansImages[company as keyof typeof ansImages]}
          alt=""
        />
      </div>
    </div>
  );
};

export default AnsDetail;
